import axios from "axios";

export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  jwtConfig = {};

  token_expiration_error_codes = ["INVALID_ACCESS_TOKEN", "INVALID_TOKEN", "UNAUTHORIZED_TOKEN", "BLACKLISTED_TOKEN"]

  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false;

  // ** For Refreshing Token
  subscribers = [];

  constructor(jwtOverrideConfig) {
    this.jwtConfig = {...jwtOverrideConfig };

    // ** Request Interceptor
    axios.interceptors.request.use(
      (config) => {
        // ** Get token from localStorage
        const accessToken = this.getToken();

        // ** If token is present add it to request's Authorization Header
        if (accessToken) {
          // ** eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // ** Add request/response interceptor
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // ** const { config, response: { status } } = error
        const { config, response } = error;
        const originalRequest = config;

        // ** if (status === 401) {
        console.log(response, error, response.status);
        if (
          response &&
          (response.status === 401 || response.status === 403) &&
            response.headers['error-code'] &&
            this.token_expiration_error_codes.includes(response.headers['error-code']) &&
          !originalRequest.url.includes("/auth/login/")
        ) {
          if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true;
            this.refreshToken().then((r) => {
              this.isAlreadyFetchingAccessToken = false;

              // ** Update accessToken in localStorage
              this.setToken(r.data.access_token);
              // ** As COGNITO-Olympus update refresh token is no longer returned, is always the same.
              // this.setRefreshToken(r.data.refresh_token);

              this.onAccessTokenFetched(r.data.access_token);
            }).catch((err) => {
              this.isAlreadyFetchingAccessToken = false;
              localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
              localStorage.removeItem(this.jwtConfig.storageRefreshTokenKeyName)
              localStorage.removeItem('userData')
              window.location.href = '/'
            });
          }
          const retryOriginalRequest = new Promise((resolve) => {
            this.addSubscriber((accessToken) => {
              // ** Make sure to assign accessToken according to your response.
              // ** Check: https://pixinvent.ticksy.com/ticket/2413870
              // ** Change Authorization header
              originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`;
              resolve(axios(originalRequest));
            });
          });
          return retryOriginalRequest;
        }
        return Promise.reject(error);
      }
    );
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter((callback) => callback(accessToken));
  }

  addSubscriber(callback) {
    this.subscribers.push(callback);
  }

  //{ "auth_session": "string", "challenge_name": "string","challenge_responses": {}}
  respondToChallenge(...args) {
    return axios.post(this.jwtConfig.challengeEndpoint, ...args);
  }

  getToken() {
    let token_ = ''
    try {
      token_ = JSON.parse(localStorage.getItem(this.jwtConfig.storageTokenKeyName))
    } catch (e) {
      console.log('Error Parsing JSON Web Token')
      token_ = localStorage.getItem(this.jwtConfig.storageTokenKeyName);
    } finally {
      return token_
    }
  }

  getRefreshToken() {
    let token_ = ''
    try {
      token_ = JSON.parse(localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName))
    } catch (e) {
      console.log('Error Parsing JSON Web Token')
      token_ = localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName);
    } finally {
      return token_
    }
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, JSON.stringify(value))
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, JSON.stringify(value))
  }

  login(...args) {
    return axios.post(this.jwtConfig.loginEndpoint, ...args);
  }

  logout(...args) {
    return axios.post(this.jwtConfig.logoutEndpoint, ...args);
  }

  register(...args) {
    console.log(this.jwtConfig);
    return axios.post(this.jwtConfig.registerEndpoint, ...args);
  }

  refreshToken() {
    return axios.post(this.jwtConfig.refreshEndpoint, {
      refresh_token: this.getRefreshToken(),
    });
  }

  sendVerificationEmail(...args) {
    return axios.post(this.jwtConfig.sendVerificationEmailEndpoint, ...args);
  }

  verifyEmail(...args) {
    return axios.post(this.jwtConfig.verifyEmailEndpoint, ...args);
  }

  activateAccount(id, email) {
    return axios.post(`${this.jwtConfig.activationAccountEndpoint}?user_id=${id}`, {email});
  }

  forgotPassword(...args) {
    return axios.post(this.jwtConfig.forgotPasswordEndpoint, ...args);
  }

  changePassword(...args) {
    return axios.post(this.jwtConfig.changePasswordEndpoint, ...args);
  }

  changeTempPassword(...args) {
    return axios.post(this.jwtConfig.changeTempPasswordEndpoint, ...args);
  }
}
